import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { GrPowerReset } from 'react-icons/gr';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { BsCheck } from 'react-icons/bs';
import { ImFilter } from 'react-icons/im';

const Header2 = ({ setStatus, setIsVerified, resetFilter }) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const [isTypeOpen, setIsTypeOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);

  const statusRef = useRef(null);
  const typeRef = useRef(null);

  const statusOptions = [
    { value: 'Active', label: 'Successful' },
    { value: 'Inactive', label: 'Failed' },
  ];

  const typeOptions = [
    { value: 'subscription', label: 'Subscription' },
    { value: 'advertisement', label: 'Advertisement' },
    { value: 'services', label: 'Services & Industry' },
    { value: 'fashion', label: 'Fashion & Beauty' },
    { value: 'home', label: 'Home & Living' },
    { value: 'electronics', label: 'Electronics' },
    { value: 'mobile', label: 'Mobile & Phone' },
    { value: 'accessories', label: 'Accessories' },
  ];

  useEffect(() => {
    function handleClickOutside(event) {
      if (statusRef.current && !statusRef.current.contains(event.target)) {
        setIsStatusOpen(false);
      }
      if (typeRef.current && !typeRef.current.contains(event.target)) {
        setIsTypeOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [statusRef, typeRef]);

  const toggleStatus = value => {
    setSelectedStatus(prev =>
      prev.includes(value) ? prev.filter(item => item !== value) : [...prev, value]
    );
  };

  const toggleType = value => {
    setSelectedTypes(prev =>
      prev.includes(value) ? prev.filter(item => item !== value) : [...prev, value]
    );
  };

  useEffect(() => {
    if (selectedStatus.length > 0) {
      setStatus(selectedStatus);
    }
  }, [selectedStatus, setStatus]);

  useEffect(() => {
    if (selectedTypes.length > 0) {
      setIsVerified(selectedTypes);
    }
  }, [selectedTypes, setIsVerified]);

  const handleResetFilter = () => {
    setSelectedStatus([]);
    setSelectedTypes([]);
    resetFilter();
    setIsFilterOpen(false);
  };

  return (
    <div className="flex items-center justify-between mb-8 font-nohemi">
      <div className="relative inline-flex justify-evenly items-center w-[450px] h-[42px] bg-[#eeeded] border rounded-lg">
        <div className="flex justify-center items-center text-[#000000] border-r border-gray-300 pr-2.5">
          <ImFilter
            className="w-4 h-4 fill-gray-900"
            onClick={() => setIsFilterOpen(!isFilterOpen)}
          />
        </div>
        <div className="flex items-center h-full px-2 border-r border-gray-300">
          <p className="text-xs font-semibold text-[#202224]">Filter by</p>
        </div>

        <div
          className="relative flex items-center h-full px-2 border-r border-gray-300"
          ref={statusRef}>
          <button
            className="flex items-center justify-between w-full cursor-pointer"
            onClick={() => setIsStatusOpen(!isStatusOpen)}>
            <span className="text-xs font-semibold text-[#ADAEB0]">
              {selectedStatus.length > 0
                ? `Order Status (${selectedStatus.length})`
                : 'Order Status'}
            </span>
            {isStatusOpen ? <IoIosArrowUp size={12} /> : <IoIosArrowDown size={12} />}
          </button>

          {isStatusOpen && (
            <div className="absolute left-0 z-10 bg-white border rounded-md shadow-lg top-8 w-72">
              <div className="grid grid-cols-2 gap-1 p-2">
                {statusOptions.map(option => (
                  <button
                    key={option.value}
                    className="flex items-center px-3 py-2 rounded cursor-pointer hover:bg-gray-100"
                    onClick={() => toggleStatus(option.value)}>
                    <div
                      className={`w-4 h-4 border rounded flex items-center justify-center mr-2 ${
                        selectedStatus.includes(option.value)
                          ? 'bg-blue-500 border-blue-500'
                          : 'border-gray-300'
                      }`}>
                      {selectedStatus.includes(option.value) && <BsCheck className="text-white" />}
                    </div>
                    <span className="text-sm whitespace-nowrap">{option.label}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        <div
          className="relative flex items-center h-full px-2 border-r border-gray-300"
          ref={typeRef}>
          <button
            className="flex items-center justify-between w-full cursor-pointer"
            onClick={() => setIsTypeOpen(!isTypeOpen)}>
            <span className="text-xs font-semibold text-[#ADAEB0]">
              {selectedTypes.length > 0 ? `Order Type (${selectedTypes.length})` : 'Order Type'}
            </span>
            {isTypeOpen ? <IoIosArrowUp size={12} /> : <IoIosArrowDown size={12} />}
          </button>

          {isTypeOpen && (
            <div className="absolute left-0 z-10 bg-white border rounded-md shadow-lg top-8 w-96">
              <div className="grid grid-cols-3 gap-1 p-2">
                {typeOptions.map(option => (
                  <button
                    key={option.value}
                    className="flex items-center px-2 py-2 rounded cursor-pointer hover:bg-gray-100"
                    onClick={() => toggleType(option.value)}>
                    <div
                      className={`w-4 h-4  border rounded flex items-center justify-center mr-1 ${
                        selectedTypes.includes(option.value)
                          ? 'bg-black border-black'
                          : 'border-gray-300'
                      }`}>
                      {selectedTypes.includes(option.value) && <BsCheck className="text-white" />}
                    </div>
                    <span className="text-[10px] whitespace-nowrap">{option.label}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        <button className="flex items-center h-full cursor-pointer" onClick={handleResetFilter}>
          <p className="text-xs font-semibold inline-flex text-[#EA0234]">
            <span className="mx-1 my-auto">
              <GrPowerReset size={12} />
            </span>{' '}
            Reset
          </p>
        </button>
      </div>
    </div>
  );
};

Header2.propTypes = {
  setStatus: PropTypes.func.isRequired,
  setIsVerified: PropTypes.func.isRequired,
  resetFilter: PropTypes.func.isRequired,
};

export default Header2;
